package or.garden.manager.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class GroqRequest(
    val crops: List<CropData>,
    val bed: BedData,
    val includePathways: Boolean = true,
    val pathwayWidth: Int? = 40
)

@Serializable
data class PlantingSuggestionsResponse(
    val plantedCrops: List<PlantedCrop>,
    val layoutGuidelines: LayoutGuidelines,
    val rotationPlan: RotationPlan,
    val practicalAdvice: List<String>,
    val fertilizationPlan: FertilizationPlan? = null
)

@Serializable
data class FertilizationPlan(
    val transplantingPhase: PhaseAdvice,
    val floweringPhase: PhaseAdvice,
    val fruitingPhase: PhaseAdvice
)

@Serializable
data class PhaseAdvice(
    val ratio: String, // e.g., "15:15:15"
    val advice: String
)

@Serializable
data class LayoutGuidelines(
    val reasoning: String,
    val sequentialZones: List<SequentialZone>,
    val irrigationAdvice: String,
    val generalAdvice: String
)

@Serializable
data class SequentialZone(
    val zoneNumber: Int,
    val zoneType: String, // "crop" or "pathway"
    val lengthCm: Int,
    val startPosition: Int,
    val endPosition: Int,
    val cropAllocation: CropAllocation? = null,
    val pathwayWidth: Int? = null
)

@Serializable
data class CropAllocation(
    val cropId: Int,
    val cropName: String,
    val companionPlants: List<CompanionPlant> = emptyList()
)

@Serializable
data class CompanionPlant(
    val name: String,
    val placementAdvice: String,
    val reasoning: String
)

@Serializable
data class RotationPlan(
    val nextSeason: List<NextSeasonCrop>,
    val soilAmendments: String
)

@Serializable
data class NextSeasonCrop(
    val afterCrop: String,
    val plantNext: List<String>,
    val reasoning: String
)
